import getWithToken from './base/get-with-token'

const getTaxonomyBenchmark = id => getWithToken(`/customer-taxonomy/${id}/benchmark`)()

export default getTaxonomyBenchmark
